/* eslint-disable @typescript-eslint/no-explicit-any */
import $ from "jquery";
import { useEffect, useRef } from "react";

interface UseFloatingScrollProps {
  containerRef: React.RefObject<HTMLDivElement | null>;
  isFloatingFooter: boolean;
  pageIndex: number;
  pageSize: number;
  width: number | undefined;
  loading: boolean;
}

export const useFloatingScroll = ({
  containerRef,
  isFloatingFooter,
  pageIndex,
  pageSize,
  width,
  loading,
}: UseFloatingScrollProps) => {
  const lastWidthRef = useRef<number | undefined>(undefined);
  const prevLoadingRef = useRef<boolean>(loading);

  // Initialize floating scroll and update styles
  useEffect(() => {
    const el = containerRef.current;
    if (isFloatingFooter && el) {
      // Initialize plugin if not already present
      if (($(el) as any).find(".fl-scrolls").length < 1) {
        ($(el) as any).find(".table-container").floatingScroll();
      }

      // Update styles after initialization or page change
      setTimeout(() => {
        ($(el) as any).find(".table-container").floatingScroll("update");
        const flScrollsEl = ($(el) as any).find(".fl-scrolls");
        flScrollsEl.css(
          "margin-bottom",
          ($(el) as any).find(".table-footer").height() || "51px"
        );
        ($(el) as any)
          .find(".table-container")
          .css(
            "margin-bottom",
            Number.parseInt(($(".table-footer") as any).height()) - 27 + "px" ||
              "51px"
          );
      }, 50);
    }
    return () => {
      if (el) ($(el) as any).find(".table-container").floatingScroll("destroy");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, pageSize]);

  // Update floating scroll when data finishes loading
  useEffect(() => {
    // Trigger update when loading changes from true to false (data loaded)
    const wasLoading = prevLoadingRef.current;
    prevLoadingRef.current = loading;

    if (wasLoading && !loading && isFloatingFooter) {
      setTimeout(() => {
        const el = containerRef.current;
        if (el) {
          ($(el) as any).find(".table-container").floatingScroll("update");
        }
      }, 50);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  // Update floating scroll on width changes
  useEffect(() => {
    // Skip if width hasn't changed
    if (width === lastWidthRef.current) return;
    lastWidthRef.current = width;

    if (isFloatingFooter) {
      setTimeout(() => {
        const el = containerRef.current;

        if (el)
          ($(el) as any).find(".table-container").floatingScroll("update");
        const flScrollsEl = $(".fl-scrolls") as any;
        flScrollsEl.css(
          "margin-bottom",
          el ? ($(el) as any).find(".table-footer").height() || "51px" : "51px"
        );
        if (el) {
          ($(el) as any)
            .find(".table-container")
            .css(
              "margin-bottom",
              Number.parseInt(($(".table-footer") as any).height()) - 27 +
                "px" || "51px"
            );
        }
      }, 10);
    }
    if (width) {
      const el = containerRef.current;
      if (el) ($(el) as any).find(".table-footer").width(width);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);
};
